import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import useScrollTrigger from "@mui/material/useScrollTrigger";

import "./ScrollTop.css";

function ScrollToTop(props) {
	const { children, window } = props;
	const trigger = useScrollTrigger({
		target: window ? window() : undefined,
		threshold: 200,
	});

	const handleClick = (event) => {
		const anchor = (event.target.ownerDocument || document).querySelector(
			"#back-to-top-anchor"
		);

		if (anchor) {
			anchor.scrollIntoView({
				block: "end",
				behavior: "smooth",
			});
		}
	};

	return (
		<Fade in={trigger}>
			<Box
				onClick={handleClick}
				role="presentation"
				sx={{ position: "fixed", bottom: 16, right: 16 }}
			>
				{children}
			</Box>
		</Fade>
	);
}

export const ScrollTop = (props) => {
	return (
		<ScrollToTop {...props}>
			<div className="scroll-to-top-icon-container">
				<img
					alt={"up"}
					src={require("../../assets/icons/up.webp")}
					className="scroll-to-top-icon"
				/>
			</div>
		</ScrollToTop>
	);
};
